import { useCallback, useState } from 'react'
import ApiRoute from '../../../components/ApiRoute'

const ContactField = ({ label, field, value, onChange, onPatch, patchDisabled, isApiCalling, type, options }) => {
  return (
    <div className='grid grid-cols-[120px_1fr_auto] gap-2 items-center py-1'>
      <label htmlFor={field} className='text-sm font-bold text-black text-right pr-2'>
        {label}
      </label>
      {type === 'select'
        ? (
          <select
            id={field}
            name={field}
            onChange={(e) => onChange(field, e.target.value)}
            value={value || ''}
            className='border border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2'
          >
            <option value=''>Select...</option>
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          )
        : (
          <input
            type='text'
            id={field}
            name={field}
            onChange={(e) => onChange(field, e.target.value)}
            value={value || ''}
            className='border border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2'
          />
          )}
      <ApiRoute method='PATCH' route='/contact/{contactId}' onClick={() => onPatch(field)} disabled={isApiCalling || patchDisabled} />
    </div>
  )
}

const Contact = ({ activeSession, callApiFn, isApiCalling }) => {
  const [values, setValues] = useState(activeSession?.contact || {})

  const updateField = useCallback((field, value) => {
    setValues({
      ...values,
      [field]: value
    })
  }, [values])

  const getContact = () => {
    callApiFn({
      method: 'GET',
      route: '/contact/{id}',
      saveSuccessPath: 'contact'
    })
  }

  const patchContact = useCallback(async (field) => {
    await callApiFn({
      method: 'PATCH',
      route: '/contact/{id}',
      body: {
        [field]: values[field]
      },
      saveSuccessPath: 'contact'
    })
  }, [values])

  const putContact = useCallback(async () => {
    await callApiFn({
      method: 'PUT',
      route: '/contact/{id}',
      body: values,
      saveSuccessPath: 'contact'
    })
  }, [values])

  const createContact = useCallback(async () => {
    await callApiFn({
      method: 'POST',
      route: '/contact',
      body: values,
      saveSuccessPath: 'contact'
    })
  }, [values])

  const patchDisabled = !activeSession?.contact

  const fields = [
    { label: 'Zip Code', field: 'zip' },
    { label: 'Fips Code', field: 'fips' },
    { label: 'Sex', field: 'sex', type: 'select', options: [{ value: 'M', label: 'M' }, { value: 'F', label: 'F' }] },
    { label: 'Date of Birth', field: 'dateOfBirth' },
    { label: 'Has Medicare?', field: 'hasMedicare', type: 'select', options: [{ value: 'true', label: 'true' }, { value: 'false', label: 'false' }] }
  ]

  return (
    <div>
      {activeSession?.contact && (
        <div className='mb-2 text-sm'>
          <span className='font-bold'>Contact ID:</span> {activeSession.contact.id || JSON.stringify(activeSession.contact)}
        </div>
      )}

      <div className='mb-3'>
        {fields.map(({ label, field, type, options }) => (
          <ContactField
            key={field}
            label={label}
            field={field}
            type={type}
            options={options}
            value={values[field]}
            onChange={updateField}
            onPatch={patchContact}
            patchDisabled={patchDisabled}
            isApiCalling={isApiCalling}
          />
        ))}
      </div>

      <div className='flex gap-2 flex-wrap'>
        <ApiRoute method='POST' route='/contact' onClick={createContact} disabled={isApiCalling} />
        <ApiRoute method='PUT' route='/contact/{contactId}' onClick={putContact} disabled={isApiCalling || patchDisabled} />
        <ApiRoute method='GET' route='/contact/{contactId}' onClick={getContact} disabled={isApiCalling || patchDisabled} />
      </div>
    </div>
  )
}

export default Contact
